import { render, staticRenderFns } from "./Rdialog.vue?vue&type=template&id=b3e37c54&scoped=true&"
import script from "./Rdialog.vue?vue&type=script&lang=js&"
export * from "./Rdialog.vue?vue&type=script&lang=js&"
import style0 from "./Rdialog.vue?vue&type=style&index=0&id=b3e37c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e37c54",
  null
  
)

export default component.exports